"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USDManager = void 0;
const types_1 = require("./types");
const USD_INITIALIZATION_TIMEOUT = 5000;
class USDManager {
    constructor(windowFunctions) {
        this.init = () => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                setTimeout(() => reject(new Error('Timeout in usd initialization')), USD_INITIALIZATION_TIMEOUT);
                try {
                    window.setAgentClientData = (data) => {
                        try {
                            this.data = data;
                            this.parseInformation(data);
                            this.parseMethods(data);
                            this.initMethods();
                            resolve(data);
                        }
                        catch (e) {
                            reject(e);
                        }
                    };
                }
                catch (error) {
                    reject(error);
                }
            });
        });
        this.loadFromData = (data) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                setTimeout(() => reject(new Error('Timeout in usd initialization')), USD_INITIALIZATION_TIMEOUT);
                try {
                    this.data = data;
                    this.parseInformation(data);
                    this.parseMethods(data);
                    this.saveSecureCopy();
                    this.initMethodsFromData();
                    resolve(data);
                }
                catch (e) {
                    reject(e);
                }
            });
        });
        this.getInformation = () => {
            if (!this.information) {
                throw new Error('should initialize information');
            }
            return this.information;
        };
        this.getMethods = () => {
            if (!this.methods) {
                throw new Error('should initialize methods');
            }
            return this.methods;
        };
        this.saveSecureCopy = () => {
            if (!window.secureCopy) {
                window.secureCopy = {
                    createPasswordOnboardingFinished: window.createPasswordOnboardingFinished,
                    invalidateSessionTokens: window.invalidateSessionTokens,
                    notifyInteractionEnded: window.notifyInteractionEnded,
                    RaiseN2InIvrFailure: window.RaiseN2InIvrFailure,
                    RaiseN2InIvrSuccess: window.RaiseN2InIvrSuccess,
                    RaiseN2OTPInIvrFailure: window.RaiseN2OTPInIvrFailure,
                    RaiseN2OTPInIvrSuccess: window.RaiseN2OTPInIvrSuccess,
                    refreshAgentToken: window.refreshAgentToken,
                    refreshSessionTokens: window.refreshSessionTokens,
                    updateSignatureKeyFailure: window.updateSignatureKeyFailure,
                    updateSignatureKeySuccess: window.updateSignatureKeySuccess,
                    verifyDataInIvrFailure: window.verifyDataInIvrFailure,
                    verifyDataInIvrSuccess: window.verifyDataInIvrSuccess,
                };
            }
        };
        this.initMethods = () => {
            window.refreshAgentToken = this.windowFunctions.refreshAgentToken;
            window.invalidateSessionTokens = this.windowFunctions.invalidateSessionTokens;
            window.refreshSessionTokens = this.windowFunctions.refreshSessionTokens;
            window.notifyInteractionEnded = this.windowFunctions.notifyInteractionEnded;
            window.RaiseN2InIvrSuccess = this.windowFunctions.RaiseN2InIvrSuccess;
            window.RaiseN2InIvrFailure = this.windowFunctions.RaiseN2InIvrFailure;
            window.RaiseN2OTPInIvrSuccess = this.windowFunctions.RaiseN2OTPInIvrSuccess;
            window.RaiseN2OTPInIvrFailure = this.windowFunctions.RaiseN2OTPInIvrFailure;
            window.updateSignatureKeySuccess = this.windowFunctions.updateSignatureKeySuccess;
            window.updateSignatureKeyFailure = this.windowFunctions.updateSignatureKeyFailure;
            window.createPasswordOnboardingFinished = this.windowFunctions.createPasswordOnboardingFinished;
            window.verifyDataInIvrSuccess = this.windowFunctions.verifyDataInIvrSuccess;
            window.verifyDataInIvrFailure = this.windowFunctions.verifyDataInIvrFailure;
        };
        this.initMethodsFromData = () => {
            this.overrideMethods();
        };
        this.windowFunctions = windowFunctions;
    }
    overrideMethods() {
        Object.keys(types_1.MethodsExposeToWindow).forEach(key => {
            const previousMethod = window.secureCopy[key];
            window[key] = (...args) => {
                this.windowFunctions[key](...args);
                previousMethod(...args);
            };
        });
    }
}
exports.USDManager = USDManager;
//# sourceMappingURL=abstractManager.js.map